/*
 * Created on Fri Nov 24 2017
 *
 * Copyright (c) 2017 Sébastien Hecart
 */
import { P01CREALOGCOL_State } from '@batical/types/src'

// res_sommeBesoinChauffage: 0,
//   res_sommeBesoinECS: 0,
//   res_puissanceChaufferie: 0,
//   res_puissnaceUnitaire: 0
function P01CREALOGCOL_docalcul(state: P01CREALOGCOL_State) {
  //some controle check
  if (state.in_nbProductionECS === 0 && state.compilation_uuid !== '7') {
    state.compilation_uuid = '7'
  }
  state.res_sommeBesoinChauffage = 0
  state.res_sommeBesoinECS = 0
  state.batiments.forEach(bat => {
    state.res_sommeBesoinChauffage += bat.in_puissance
  })
  state.productionECS.forEach(ecs => {
    state.res_sommeBesoinECS += ecs.in_puissance
  })

  //calcul basé sur la methode de calcul repartiion Chauffage/ECS
  // compilation_somme_0: '100% chauffage + 100% ECS',
  // compilation_somme_1: '50% chauffage + 100% ECS',
  // compilation_somme_2: '75% chauffage + 75% ECS',
  // compilation_somme_3: '50% chauffage + 50% ECS',
  // compilation_somme_4: '80% chauffage + 20% ECS',
  // compilation_somme_5: '100% max(CH;ECS) + 30% min(CH;ECS)',
  // compilation_somme_6: '120% max(CH;ECS)',
  // compilation_somme_7: '100% Chauffage',
  // compilation_somme_libre: 'Ratio libre',
  let puissanceChauffageRetenu = 0
  let puissancECSRetenu = 0
  switch (state.compilation_uuid) {
    case '0':
      puissanceChauffageRetenu = state.res_sommeBesoinChauffage
      puissancECSRetenu = state.res_sommeBesoinECS
      break
    case '1':
      puissanceChauffageRetenu = state.res_sommeBesoinChauffage / 2
      puissancECSRetenu = state.res_sommeBesoinECS
      break
    case '2':
      puissanceChauffageRetenu = 0.75 * state.res_sommeBesoinChauffage
      puissancECSRetenu = 0.75 * state.res_sommeBesoinECS
      break
    case '3':
      puissanceChauffageRetenu = 0.5 * state.res_sommeBesoinChauffage
      puissancECSRetenu = state.res_sommeBesoinECS * 0.5
      break
    case '4':
      puissanceChauffageRetenu = state.res_sommeBesoinChauffage * 0.8
      puissancECSRetenu = state.res_sommeBesoinECS * 0.2
      break
    case '5':
      puissanceChauffageRetenu =
        state.res_sommeBesoinChauffage >= state.res_sommeBesoinECS ? state.res_sommeBesoinChauffage : state.res_sommeBesoinChauffage * 0.3
      puissancECSRetenu =
        state.res_sommeBesoinChauffage < state.res_sommeBesoinECS ? state.res_sommeBesoinECS : state.res_sommeBesoinECS * 0.3
      break
    case '6':
      puissanceChauffageRetenu = state.res_sommeBesoinECS <= state.res_sommeBesoinChauffage ? state.res_sommeBesoinChauffage * 1.2 : 0
      puissancECSRetenu = state.res_sommeBesoinChauffage < state.res_sommeBesoinECS ? state.res_sommeBesoinECS * 1.2 : 0
      break
    case '7':
      puissanceChauffageRetenu = state.res_sommeBesoinChauffage
      puissancECSRetenu = 0
      break
    case 'libre':
      puissanceChauffageRetenu = (state.res_sommeBesoinChauffage * state.in_percentChauffage) / 100
      puissancECSRetenu = (state.res_sommeBesoinECS * state.in_percentECS) / 100
      break
  }

  let pourcentSurpuissanceFactor = Number(state.surpuissance_percent_uuid) / 100 + 1
  switch (state.surpuissance_uuid) {
    case '0':
      state.res_puissanceChaufferie = pourcentSurpuissanceFactor * (puissanceChauffageRetenu + puissancECSRetenu)
      break
    case '1':
      state.res_puissanceChaufferie = pourcentSurpuissanceFactor * puissancECSRetenu + puissanceChauffageRetenu
      break
    case '2':
      state.res_puissanceChaufferie = pourcentSurpuissanceFactor * puissanceChauffageRetenu + puissancECSRetenu
      break
    case 'none':
      state.res_puissanceChaufferie = puissanceChauffageRetenu + puissancECSRetenu
      break
  }
  state.res_puissnaceUnitaire = state.res_puissanceChaufferie / state.in_nbGenerateur
  //some checking to avoid screw up and mess
  if (state.batiments) {
    state.in_nombreBatiment = state.batiments.length
  } else {
    state.in_nombreBatiment = 0
  }
  if (state.productionECS) {
    state.in_nbProductionECS = state.productionECS.length
  } else {
    state.in_nbProductionECS = 0
  }
  return state
}

export default P01CREALOGCOL_docalcul
